var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShareOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.16668 10.3333V3.54167L4.00001 5.70834L2.83334 4.5L7.00001 0.333336L11.1667 4.5L10 5.70834L7.83334 3.54167V10.3333H6.16668ZM2.00001 13.6667C1.54168 13.6667 1.14932 13.5035 0.822927 13.1771C0.496538 12.8507 0.333344 12.4583 0.333344 12V9.5H2.00001V12H12V9.5H13.6667V12C13.6667 12.4583 13.5035 12.8507 13.1771 13.1771C12.8507 13.5035 12.4583 13.6667 12 13.6667H2.00001Z",
    fill: "#1D1B20"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareOutline);
export default __webpack_public_path__ + "static/media/share-outline.70d7d9ae2dcb81ba69801c9f1aaf8f23.svg";
export { ForwardRef as ReactComponent };